// src/features/notifications/notificationsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  unreadCount: 0,
  latestNotifications: [], // حداکثر 50 اعلان آخر
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification: (state, action) => {
      const newNotif = action.payload;
      // جلوگیری از تکرار (بر اساس id)
      if (!state.latestNotifications.some(n => n._id === newNotif._id)) {
        state.latestNotifications = [newNotif, ...state.latestNotifications].slice(0, 50);
        if (!newNotif.read) state.unreadCount += 1;
      }
    },
    setUnreadList: (state, action) => {
      const list = action.payload;
      state.latestNotifications = list;
      state.unreadCount = list?.filter(n => !n.read).length;
    },
    decrementUnread: (state) => {
      if (state.unreadCount > 0) state.unreadCount -= 1;
    },
    resetUnread: (state) => {
      state.unreadCount = 0;
    },
  },
});

export const { addNotification, setUnreadList, decrementUnread, resetUnread } = notificationsSlice.actions;
export default notificationsSlice.reducer;